import { Fragment } from "react";
import PublicHeader from "../../components/layouts/PublicHeader";
import { Link, ScrollRestoration } from "react-router-dom";
import { getLanguageContent } from "../../utils/language/languageSelector";
import { WHO_WE_HELP_SCHEMA } from "../../utils/schemas/language/pages/whoWeHelpSchema";
import WhoWeHelpHeaderRight from "./whowehelp/WhoWeHelpHeaderRight";

function WhoWeHelp({ langKey }) {
  const content = getLanguageContent(WHO_WE_HELP_SCHEMA, langKey);

  const renderIdentifierSection = (section) => (
    <div
      className="zpattern-two-sections-card"
      id={section.id}
      key={section.id}
    >
      <div className="zpattern-left-section-card">
        <img
          src={section.image}
          alt={section.image_alt}
          style={{ maxWidth: "100%", objectFit: "contain" }}
        ></img>
      </div>
      <div className="zpattern-right-section-card">
        <div className="group-content">
          <h4>{section.heading}</h4>
          {section.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
          <div className="list-container">
            {section.list_items.map((item, index) => (
              <div className="list-item" key={index}>
                <img
                  src="/images/icons/verified_gray.svg"
                  alt=""
                  className="list-item-icon"
                ></img>
                <span className="list-item-span">{item}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="cta-group">
          {section.ctas.map((cta) => (
            <Link
              className={`cta-button ${cta.type}`}
              to={cta.link}
              key={`${cta.text}-${cta.link}`}
            >
              {cta.text}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <Fragment>
      <ScrollRestoration />
      <PublicHeader
        title={content.title}
        subtitle={content.sub_title}
        ctas={content.hero_ctas}
        right_content={<WhoWeHelpHeaderRight cards={content.hero_cards} />}
      />
      <div id="container">
        <div className="fi-ecosystem-zpattern-container padding-top-button">
          {content.identifier_sections.map(renderIdentifierSection)}
        </div>
      </div>
    </Fragment>
  );
}

export default WhoWeHelp;
